"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustmentRfidLogTypes = void 0;
exports.adjustmentRfidLogTypes = {
    SET_ERROR: 'RFID LOG TYPES SET ERROR',
    SET_LOADING: 'RFID LOG TYPES SET LOADING',
    SET_DATA_GRID: 'RFID LOG TYPES GET DATA GRID',
    SET_DATA_GRID_EXPORT_EXCEL: 'RFID LOG TYPES GET DATA GRID EXPORT EXCEL',
    ON_PAGE_CHANGE: 'RFID LOG TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'RFID LOG TYPES ON MUTATION',
    ON_SORT_CHANGE: 'RFID LOG TYPES ON SORT CHANGE',
    ON_FILTER_CHANGE: 'RFID LOG TYPES ON FILTER CHANGE',
    ON_CHANGE_DATAITEM: 'RFID LOG TYPES ON CHANGE DATAITEM',
    SET_DATA_DROPDOWN_POS: 'RFID LOG TYPES SET DATA DROPDOWN POS',
    SET_DATA_DROPDOWN_AREA: 'RFID LOG TYPES SET DATA DROPDOWN AREA',
};
